import React from "react"
import {AllowedTransactionsColumns, TransactionsColumns} from "./Transactions.types"
import {Transaction} from "../../resources/transaction"
import {Resource} from "../../resources/common"
import {DataTable, DataTableBody, DataTableCell, DataTableHead, DataTableRow} from "../DataTable/DataTable"
import PagingNavBar from "../PagingNavBar/PagingNavBar"
import TransactionRow from "./TransactionRow"
import classNames from "classnames"

interface TransactionsTableProps {
	transactions: Array<Transaction>
	hasResults: boolean
	hasPrev: boolean
	hasNext: boolean
	prev: () => void
	next: () => void
	isUsingPaging: boolean
	include?: Resource[]
	includedColumns: Array<AllowedTransactionsColumns>
	fullHeight: boolean
	sortFunction: () => void
	sortBy: string
	isFiltering: boolean
	isDateRangeLimited?: boolean
	hideMinHeight?: boolean
	disabled?: boolean
	onSelect?: (tx: Transaction) => void
}

export default function TransactionsTable({
	transactions,
	hasResults,
	hasPrev,
	hasNext,
	prev,
	next,
	isUsingPaging,
	include,
	includedColumns,
	fullHeight,
	sortFunction,
	sortBy,
	isFiltering,
	isDateRangeLimited = false,
	hideMinHeight,
	disabled,
	onSelect,
}: TransactionsTableProps) {
	const noContent = transactions.length === 0

	return (
		<div className={"transaction-table"}>
			<DataTable
				isEmpty={noContent}
				fullHeight={fullHeight}
				stickyTitle={fullHeight}
				stickyAction={fullHeight}
				hideMinHeight={hideMinHeight}
				noContentText={
					!isFiltering ? (
						<>
							No{" "}
							<a className="doc-link" href="https://docs.unit.co/transactions/" target="_blank" rel="noreferrer">
								{" "}
								transactions
							</a>{" "}
							yet
						</>
					) : isDateRangeLimited ? (
						<>
							No transactions found for this date range
							<span className="no-content-hint">Try adjusting your filters</span>
						</>
					) : (
						"No transactions found"
					)
				}
				disabled={disabled}
			>
				<DataTableHead className={classNames(!fullHeight && "no-sticky")}>
					<DataTableRow>
						{Object.entries(includedColumns).map((column) => {
							if (column[1] === TransactionsColumns.createdAt) {
								return (
									<DataTableCell
										clickable
										onClick={() => sortFunction()}
										key={column[1]}
										sortable
										sortApplied={sortBy === "createdAt"}
									>
										{column[1]}
									</DataTableCell>
								)
							}

							return <DataTableCell key={column[0]}>{column[1]}</DataTableCell>
						})}
					</DataTableRow>
				</DataTableHead>
				<DataTableBody>
					{transactions.map((tx) => (
						<TransactionRow
							tx={tx}
							key={`${tx.relationships.account.data.id}_${tx.id}`}
							include={include}
							includedColumns={includedColumns}
							onSelect={onSelect}
						/>
					))}
				</DataTableBody>
			</DataTable>
			<PagingNavBar
				hasResults={hasResults}
				hasPrev={hasPrev}
				hasNext={hasNext}
				prev={prev}
				next={next}
				isShow={isUsingPaging}
			/>
		</div>
	)
}
